var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemperature(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.067,
    height: 47.693,
    viewBox: "0 0 30.067 47.693",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Temperature_Scale",
    "data-name": "Temperature Scale",
    transform: "translate(-12.002 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15828",
    "data-name": "Path 15828",
    d: "M32.737,38.327a10.367,10.367,0,1,1-16.59-8.295V7.221a6.221,6.221,0,0,1,12.442,0V30.032A10.369,10.369,0,0,1,32.737,38.327Z",
    transform: "translate(0 0)",
    fill: "#acd4f8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10583",
    "data-name": "Group 10583",
    transform: "translate(33.774 5.147)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15830",
    "data-name": "Path 15830",
    d: "M38.184,7.074H34.037a1.037,1.037,0,0,1,0-2.074h4.147a1.037,1.037,0,1,1,0,2.074Z",
    transform: "translate(-33 -5)",
    fill: "#425b72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15831",
    "data-name": "Path 15831",
    d: "M40.258,12.074H34.037a1.037,1.037,0,0,1,0-2.074h6.221a1.037,1.037,0,0,1,0,2.074Z",
    transform: "translate(-33 -4.816)",
    fill: "#425b72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15832",
    "data-name": "Path 15832",
    d: "M38.184,17.074H34.037a1.037,1.037,0,0,1,0-2.074h4.147a1.037,1.037,0,1,1,0,2.074Z",
    transform: "translate(-33 -4.631)",
    fill: "#425b72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15833",
    "data-name": "Path 15833",
    d: "M40.258,22.074H34.037a1.037,1.037,0,0,1,0-2.074h6.221a1.037,1.037,0,0,1,0,2.074Z",
    transform: "translate(-33 -4.447)",
    fill: "#425b72"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15834",
    "data-name": "Path 15834",
    d: "M38.184,27.074H34.037a1.037,1.037,0,0,1,0-2.074h4.147a1.037,1.037,0,1,1,0,2.074Z",
    transform: "translate(-33 -4.263)",
    fill: "#425b72"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15835",
    "data-name": "Path 15835",
    d: "M28.442,37.737a6.221,6.221,0,1,1-8.295-5.858V17h4.147V31.879A6.221,6.221,0,0,1,28.442,37.737Z",
    transform: "translate(0.147 0.59)",
    fill: "#4c36e4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15837",
    "data-name": "Path 15837",
    d: "M24.147,7.074V17.442H20V7.074a2.074,2.074,0,1,1,4.147,0Z",
    transform: "translate(0.295 1.184)",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemperature);
export default __webpack_public_path__ + "static/media/Temperature.f111d52c6f1a93f2e19a5220bc0b00fb.svg";
export { ForwardRef as ReactComponent };